import { Search } from '@local/client-contracts';

export interface SortOptions {
  text: string;
  value: Search.Sort;
  selected?: boolean;
}
